(function(angular){
	'use strict';
	
	angular
		.module('investorDashboard')
		.controller('AccountDocuments', [
			'globalConfig',
			'mixpanelFactory',
			'ReitElementFactory',
			InvestorDashboardCtrl
		]);
	
	function InvestorDashboardCtrl(
		globalConfig,
		mixpanelFactory,
		ReitElementFactory
	){
		var dashboard = this;

		dashboard.$onInit = function() {
			angular.extend(dashboard, globalConfig);

			dashboard.openDocumentIndex = {
				'TAX_DOCUMENTS': 0,
				'ACCOUNT_STATEMENTS': 0,
				'INVESTMENT_DOCUMENTS': 0
			};

			ReitElementFactory.getReitElementListsForDashboard()
				.then(function(reitElementLists) {
					angular.extend(dashboard, reitElementLists);
				});
		};

		dashboard.updateActiveDocument = function(documentType, index) {
			dashboard.openDocumentIndex[documentType] = dashboard.openDocumentIndex[documentType] === index ? undefined : index;
		};
				
		dashboard.trackDocumentLink = function(section, document, dateIssued) {
			mixpanelFactory.track('Investor Dashboard Document Clicked', {
				"Section" : section,
				"Document" : document,
				"Date Issued" : dateIssued
			});
		};
	}
})(window.angular);